import { MenuRoot, IconButton, Menu, MenuItem } from '@cimpress-ui/react';
import { IconMenuMoreVertical } from '@cimpress-ui/react/icons';

export function FulfillmentOptionHeaderActions() {
  return (
    <MenuRoot>
      <IconButton icon={<IconMenuMoreVertical />} aria-label="Menu" />
      <Menu>
        <MenuItem
          rel="noreferrer"
          target="_blank"
          href="https://cimpress-support.atlassian.net/wiki/spaces/CI/pages/16287072303/How+Routing+Chooses+a+Fulfillment+Option"
        >
          How routing chooses an option
        </MenuItem>
      </Menu>
    </MenuRoot>
  );
}
